import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";
import { DefaultCatchBoundary } from "./components/DefaultCatchBoundary";
import { NotFound } from "./components/NotFound";
import { guardDomAgainstTranslators } from "./lib/domGuard";
import { initErrorReporting, reportError } from "./lib/errorReporter";

export function getRouter() {
  // Here rather than in a component so that errors thrown before and during
  // hydration are caught too. No-op on the server.
  initErrorReporting();
  guardDomAgainstTranslators();

  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: false,
    defaultErrorComponent: DefaultCatchBoundary,
    // Errors a route's error boundary swallowed never reach window.onerror.
    defaultOnCatch: (error) => reportError("RouteError", error),
    defaultNotFoundComponent: () => <NotFound />,
  });
  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
